function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIkonaEdi1Biala({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 91 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,-70.0663,-21.6038)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.62766,0,0,0.62766,-44.4149,-47.8657)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.812808,0,76.5616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M579,206L579,409L297,409L297,206",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "6.53px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.62766,0,0,0.62766,-44.4149,-47.8657)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.936937,0,50.991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297,206L438,317L579,206",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "6.14px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.62766,0,0,0.62766,-44.4149,-47.8657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297,409L415.699,331.551M460.301,331.551L579,409",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "5.95px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.62766,0,0,0.62766,-44.4149,-47.8657)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.19198,0,0,1.19198,-81.1065,-60.5211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367,292.201L367,175L462.053,175L504,216.947L504,292.201",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "4.99px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.62766,0,0,0.62766,-44.4149,-47.8657)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.34949,45.0751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525,153L475,153L475,103L525,153Z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "5.95px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.62766,0,0,0.62766,-44.4149,-47.8657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297,244L356.349,222.954M519.651,222.954L579,244",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "5.95px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.62766,0,0,0.62766,-44.4149,-47.8657)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.69665,0,0,2.69665,-801.896,-389.402)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "439.916px",
    y: "243.474px",
    style: {
      fontFamily: "'ArialMT', 'Arial'",
      fontSize: 24,
      fill: "white"
    }
  }, "EDI")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonaEdi1Biala);
export default __webpack_public_path__ + "static/media/IkonaEDI_1_biala.886b2ec24c5615fbbe6a3cb8cdc29d95.svg";
export { ForwardRef as ReactComponent };